import { createFileRoute } from "@tanstack/react-router";
import { useMe } from "@/hooks/useCloudChat";
import { MemorySection } from "@/features/dashboard/MemorySection";

function MemoryTab() {
  const { data: me } = useMe();
  const orgId = me?.organization?.id ?? "";
  return <MemorySection orgId={orgId} />;
}

export const Route = createFileRoute("/_auth/_agents/settings/memory")({
  component: MemoryTab,
});
